var React = require('react');

function IconmonstrArrow20 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"}));
}

IconmonstrArrow20.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconmonstrArrow20;

IconmonstrArrow20.default = IconmonstrArrow20;
